import { render } from "./BalAssetSet.vue?vue&type=template&id=0d522c90&scoped=true&ts=true"
import script from "./BalAssetSet.vue?vue&type=script&lang=ts"
export * from "./BalAssetSet.vue?vue&type=script&lang=ts"

import "./BalAssetSet.vue?vue&type=style&index=0&id=0d522c90&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d522c90"]])

export default __exports__